export default __webpack_public_path__ + "static/media/p5-2.3d4b3587.png";